import { render } from "./CIS-Latest-Alert.vue?vue&type=template&id=82335120"
import script from "./CIS-Latest-Alert.vue?vue&type=script&lang=js"
export * from "./CIS-Latest-Alert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__